import ToastrTpl from './toastr.tpl.html';
import ProgressbarTpl from './progressbar.tpl.html';
import ToastrMod from './toastr.js';
const ModTpl = $templateCache => {
	$templateCache.put('directives/toast/toast.html', ToastrTpl);
	$templateCache.put('directives/progressbar/progressbar.html', ProgressbarTpl);
};
ModTpl.$inject = ['$templateCache'];
var MODULE_NAME = 'ui.bootstrap.module.toast';
let compMod = angular.module(MODULE_NAME, [ToastrMod]).run(ModTpl);
export default (compMod = compMod.name);
